import React, { useContext } from "react";

// Material UI
import Button from "@material-ui/core/Button";
import SettingsIcon from "@material-ui/icons/Settings";

// Styling
import "./style.scss";

// Global state
import { StateContext } from "../../AppStateContext";

const __addClassFormAdvancedSettingsButton = ({
  setIsClassAdvancedSettingsModalOpen,
}) => {
  const state = useContext(StateContext);

  // To open the advanced settings modal
  const openModal = () => {
    setIsClassAdvancedSettingsModalOpen(true);
  };
  return (
    <div className="__addClassFormAdvancedSettings">
      <Button
        id="addClassAdvancedSettingsButton"
        onClick={openModal}
        variant="contained"
        startIcon={
          <SettingsIcon
            style={{
              fontSize: "28px",
              color: state.theme === "dark" ? "#e2e9ff" : "#00152b",
            }}
          />
        }
        style={{
          fontFamily: "Alegreya Sans, sans-serif",
          textTransform: "capitalize",
          background: state.theme === "dark" ? "#122742" : "#e2e9ff",
          color: state.theme === "dark" ? "#e2e9ff" : "#00152b",
          fontWeight: "400",
          position: "absolute",
          bottom: "15px",
          right: "15px",
          borderRadius: "0",
          boxShadow: "none",
        }}
      >
        Advanced Settings
      </Button>
    </div>
  );
};

export default __addClassFormAdvancedSettingsButton;
